import { createContext, useContext, useState, useCallback } from "react";

const dict = {
  es: {
    "nav.inicio": "Inicio",
    "nav.actividades": "Actividades",
    "nav.sobre": "Nosotros",
    "nav.contacto": "Contacto",
    "nav.reservar": "Reservar",
    "hero.kicker": "Vizcaya · Cantabria · Norte de España",
    "hero.title.line1": "Desafía",
    "hero.title.line2": "el Norte",
    "hero.subtitle":
      "Guiados de barrancos, cuevas, vías ferratas y escalada en el corazón salvaje de Vizcaya y Cantabria. Aventura real, guías titulados, seguridad garantizada.",
    "hero.cta.primary": "Reserva tu Aventura",
    "hero.cta.secondary": "Ver Actividades",
    "about.kicker": "Sobre Sustrai Aventura",
    "about.title": "Guías locales. Aventura auténtica.",
    "about.body":
      "Nacimos donde la montaña abraza el Cantábrico, en Mungia (Bizkaia). Llevamos años explorando cada barranco escondido, cada cueva olvidada y cada vía ferrata vertiginosa del Norte. Sustrai Aventura no vende rutas turísticas: te lleva a los rincones que solo un guía local conoce.",
    "about.point1.title": "Guías titulados",
    "about.point1.body":
      "Técnicos deportivos y espeleólogos federados con años de experiencia en el terreno.",
    "about.point2.title": "Seguridad primero",
    "about.point2.body":
      "Material homologado y revisado, seguros incluidos y ratios reducidos por guía.",
    "about.point3.title": "Grupos reducidos",
    "about.point3.body":
      "Experiencias íntimas, sin masificación. Atención personalizada en cada paso.",
    "activities.kicker": "Nuestras Experiencias",
    "activities.title": "Cuatro formas de vivir el Norte",
    "activities.cta": "Descubre la actividad",
    "booking.kicker": "Reserva",
    "booking.title": "Asegura tu plaza",
    "booking.intro":
      "Cuéntanos qué aventura buscas y en qué fecha. Te responderemos en menos de 24 horas para confirmar disponibilidad y detalles.",
    "booking.label.name": "Nombre completo",
    "booking.label.email": "Email",
    "booking.label.phone": "Teléfono (opcional)",
    "booking.label.activity": "Actividad",
    "booking.label.date": "Fecha preferida",
    "booking.label.participants": "Nº de personas",
    "booking.label.level": "Nivel de experiencia",
    "booking.label.message": "Mensaje (opcional)",
    "booking.placeholder.activity": "Selecciona una actividad",
    "booking.placeholder.level": "Selecciona tu nivel",
    "booking.placeholder.date": "Elige una fecha",
    "booking.placeholder.message":
      "Cuéntanos sobre tu grupo, experiencia previa, peticiones especiales...",
    "booking.level.beginner": "Principiante",
    "booking.level.intermediate": "Intermedio",
    "booking.level.advanced": "Avanzado",
    "booking.submit": "Enviar solicitud",
    "booking.submitting": "Enviando...",
    "booking.success.title": "¡Solicitud enviada!",
    "booking.success.body":
      "Hemos recibido tu reserva. Te contactaremos en breve por email para confirmar.",
    "booking.error":
      "No hemos podido enviar tu reserva. Inténtalo de nuevo o escríbenos al email.",
    "contact.kicker": "Contacto",
    "contact.title": "Habla con un guía",
    "contact.email.label": "Escríbenos",
    "contact.location.label": "Zonas de operación",
    "contact.location.value": "Vizcaya · Cantabria, Norte de España",
    "testimonials.kicker": "Lo que dicen",
    "testimonials.title": "Aventuras vividas",
    "testimonials.empty": "Sé el primero en compartir tu experiencia.",
    "testimonials.form.title": "Deja tu reseña",
    "testimonials.form.intro": "¿Has vivido una aventura con nosotros? Comparte tu experiencia.",
    "testimonials.label.name": "Tu nombre",
    "testimonials.label.location": "Ciudad (opcional)",
    "testimonials.label.activity": "Actividad (opcional)",
    "testimonials.label.rating": "Valoración",
    "testimonials.label.message": "Tu experiencia",
    "testimonials.placeholder.message": "Cuéntanos qué te pareció la actividad, el equipo, los guías...",
    "testimonials.submit": "Publicar reseña",
    "testimonials.submitting": "Publicando...",
    "testimonials.success": "¡Gracias por tu reseña!",
    "testimonials.error": "No hemos podido publicar tu reseña. Inténtalo de nuevo.",
    "footer.tag": "Aventura guiada en el Norte de España.",
    "footer.rights": "Todos los derechos reservados.",
    "act.duration": "Duración",
    "act.difficulty": "Dificultad",
    "act.group": "Grupo",
    "act.price": "Precio",
    "act.includes": "Qué incluye",
    "act.book": "Reservar esta actividad",
    "act.back": "Volver",
  },
  en: {
    "nav.inicio": "Home",
    "nav.actividades": "Activities",
    "nav.sobre": "About",
    "nav.contacto": "Contact",
    "nav.reservar": "Book Now",
    "hero.kicker": "Vizcaya · Cantabria · Northern Spain",
    "hero.title.line1": "Challenge",
    "hero.title.line2": "the North",
    "hero.subtitle":
      "Guided canyoning, caving, via ferrata and rock climbing in the wild heart of Vizcaya and Cantabria. Real adventure, certified guides, total safety.",
    "hero.cta.primary": "Book your Adventure",
    "hero.cta.secondary": "View Activities",
    "about.kicker": "About Sustrai Aventura",
    "about.title": "Local guides. Authentic adventure.",
    "about.body":
      "We were born where the mountain meets the Cantabrian sea, in Mungia (Bizkaia). For years we have explored every hidden canyon, every forgotten cave and every vertigo-inducing via ferrata in the North. Sustrai Aventura doesn't sell tourist routes: we take you to the spots only a local guide knows.",
    "about.point1.title": "Certified guides",
    "about.point1.body":
      "Sports technicians and federated cavers with years of field experience.",
    "about.point2.title": "Safety first",
    "about.point2.body":
      "Certified, regularly checked gear, insurance included and low guide-to-client ratios.",
    "about.point3.title": "Small groups",
    "about.point3.body":
      "Intimate experiences, no crowds. Personal attention every step of the way.",
    "activities.kicker": "Our Experiences",
    "activities.title": "Four ways to live the North",
    "activities.cta": "Discover the activity",
    "booking.kicker": "Booking",
    "booking.title": "Secure your spot",
    "booking.intro":
      "Tell us which adventure you want and when. We will reply within 24h to confirm availability and details.",
    "booking.label.name": "Full name",
    "booking.label.email": "Email",
    "booking.label.phone": "Phone (optional)",
    "booking.label.activity": "Activity",
    "booking.label.date": "Preferred date",
    "booking.label.participants": "Number of people",
    "booking.label.level": "Experience level",
    "booking.label.message": "Message (optional)",
    "booking.placeholder.activity": "Select an activity",
    "booking.placeholder.level": "Select your level",
    "booking.placeholder.date": "Pick a date",
    "booking.placeholder.message":
      "Tell us about your group, previous experience, special requests...",
    "booking.level.beginner": "Beginner",
    "booking.level.intermediate": "Intermediate",
    "booking.level.advanced": "Advanced",
    "booking.submit": "Send request",
    "booking.submitting": "Sending...",
    "booking.success.title": "Request sent!",
    "booking.success.body":
      "We have received your booking. We will contact you shortly by email to confirm.",
    "booking.error":
      "We couldn't send your booking. Please try again or email us directly.",
    "contact.kicker": "Contact",
    "contact.title": "Talk to a guide",
    "contact.email.label": "Write to us",
    "contact.location.label": "Areas of operation",
    "contact.location.value": "Vizcaya · Cantabria, Northern Spain",
    "testimonials.kicker": "What they say",
    "testimonials.title": "Lived adventures",
    "testimonials.empty": "Be the first to share your experience.",
    "testimonials.form.title": "Leave your review",
    "testimonials.form.intro": "Did you join one of our adventures? Share your experience.",
    "testimonials.label.name": "Your name",
    "testimonials.label.location": "City (optional)",
    "testimonials.label.activity": "Activity (optional)",
    "testimonials.label.rating": "Rating",
    "testimonials.label.message": "Your experience",
    "testimonials.placeholder.message": "Tell us what you thought about the activity, gear, guides...",
    "testimonials.submit": "Publish review",
    "testimonials.submitting": "Publishing...",
    "testimonials.success": "Thanks for your review!",
    "testimonials.error": "We couldn't publish your review. Please try again.",
    "footer.tag": "Guided adventure in Northern Spain.",
    "footer.rights": "All rights reserved.",
    "act.duration": "Duration",
    "act.difficulty": "Difficulty",
    "act.group": "Group",
    "act.price": "Price",
    "act.includes": "What's included",
    "act.book": "Book this activity",
    "act.back": "Back",
  },
};

const LangContext = createContext({ lang: "es", t: (k) => k, toggle: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const toggle = useCallback(() => setLang((l) => (l === "es" ? "en" : "es")), []);
  const t = useCallback((key) => dict[lang][key] ?? key, [lang]);
  return (
    <LangContext.Provider value={{ lang, t, toggle, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
